import Phaser from "phaser";
import { cartesianToIsometric, isoToCoord } from "../../helpers";
export default class PnjSprite extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y, texture, name, house) {
    super(scene, x, y, texture);
    this.name = name;
    this.house = house;
    // this.currentOrientation = direction;
  }

  onTrigger() {
    let from = isoToCoord(this.x, this.y, this.scene.size.x, this.scene.size.y);
    let fromX = Math.trunc(from.i);
    let fromY = Math.trunc(from.j);

    let to = isoToCoord(
      this.house.x,
      this.house.y,
      this.scene.size.x,
      this.scene.size.y
    );
    let toX = Math.trunc(to.i) + 1;
    let toY = Math.trunc(to.j) + 1;

    this.scene.finder.findPath(fromX, fromY, toX, toY, path => {
      if (path === null) {
        console.warn("Path was not found.");
      } else {
        this.movePnj(path, this.scene);
      }
    });
    this.scene.finder.calculate();
    return this.house;
  }
  // updatePnjOrientation = game => {
  //   const vect = new Phaser.Math.Vector2(
  //     this.x - game.pnjPrev.x,
  //     this.y - game.pnjPrev.y
  //   );
  //   if (vect.angle() > 0 && vect.angle() < Math.PI / 2)
  //     game.pnjOrientation = "SE";
  //   else if (vect.angle() > Math.PI / 2 && vect.angle() < Math.PI)
  //     game.pnjOrientation = "SO";
  //   else if (vect.angle() > Math.PI && vect.angle() < (3 * Math.PI) / 2)
  //     game.pnjOrientation = "NO";
  //   else if (vect.angle() > (3 * Math.PI) / 2 && vect.angle() < 2 * Math.PI)
  //     game.pnjOrientation = "NE";
  //   game.pnjPrev = { x: this.x, y: this.y };

  //   if (vect.angle() === 0) {
  //     game.newPNJ.anims.play(`idle${this.currentOrientation}`, true);
  //   }
  //   if (game.pnjOrientation === "NO" && vect.angle() !== 0) {
  //     game.newPNJ.anims.play("NO", true);
  //   }
  //   if (game.pnjOrientation === "NE" && vect.angle() !== 0) {
  //     game.newPNJ.anims.play("NE", true);
  //   }
  //   if (game.pnjOrientation === "SE" && vect.angle() !== 0) {
  //     game.newPNJ.anims.play("SE", true);
  //   }
  //   if (game.pnjOrientation === "SO" && vect.angle() !== 0) {
  //     game.newPNJ.anims.play("SO", true);
  //   }
  //   this.currentOrientation = game.pnjOrientation;
  // };

  movePnj(path, scene) {
    let tweens = [];
    for (let i = 0; i < path.length - 1; i++) {
      let ex = path[i + 1].x;
      let ey = path[i + 1].y;
      let positionFromX = ex * scene.size.x;
      let positionFromY = ey * scene.size.y;
      let isoPt = cartesianToIsometric(positionFromX, positionFromY);

      tweens.push({
        targets: this,
        x: { value: isoPt.x, duration: 300 },
        y: { value: isoPt.y, duration: 300 }
      });
      this.setDepth(10 * positionFromX + positionFromY + 0.5);
    }

    scene.tweens.timeline({
      tweens: tweens
    });
  }

  // createAnimsPnj(game) {
  //   const frameAnimationNordOuest = game.anims.generateFrameNames("pnj", {
  //     start: 0,
  //     end: 8,
  //     zeroPad: 3,
  //     suffix: ".png"
  //   });
  //   const frameAnimationNordEst = game.anims.generateFrameNames("pnj", {
  //     start: 9,
  //     end: 16,
  //     zeroPad: 3,
  //     suffix: ".png"
  //   });
  //   const frameAnimationSudEst = game.anims.generateFrameNames("pnj", {
  //     start: 27,
  //     end: 36,
  //     zeroPad: 3,
  //     suffix: ".png"
  //   });
  //   const frameAnimationSudOuest = game.anims.generateFrameNames("pnj", {
  //     start: 17,
  //     end: 26,
  //     zeroPad: 3,
  //     suffix: ".png"
  //   });
  //   const idleNO = game.anims.generateFrameNames("pnj", {
  //     start: 0,
  //     end: 0,
  //     zeroPad: 3,
  //     suffix: ".png"
  //   });
  //   const idleNE = game.anims.generateFrameNames("pnj", {
  //     start: 9,
  //     end: 9,
  //     zeroPad: 3,
  //     suffix: ".png"
  //   });
  //   const idleSO = game.anims.generateFrameNames("pnj", {
  //     start: 17,
  //     end: 17,
  //     zeroPad: 3,
  //     suffix: ".png"
  //   });
  //   const idleSE = game.anims.generateFrameNames("pnj", {
  //     start: 27,
  //     end: 27,
  //     zeroPad: 3,
  //     suffix: ".png"
  //   });

  //   game.anims.create({
  //     key: "NO",
  //     frames: frameAnimationNordOuest,
  //     frameRate: 10,
  //     repeat: -1
  //   });
  //   game.anims.create({
  //     key: "NE",
  //     frames: frameAnimationNordEst,
  //     frameRate: 10,
  //     repeat: -1
  //   });
  //   game.anims.create({
  //     key: "SE",
  //     frames: frameAnimationSudEst,
  //     frameRate: 10,
  //     repeat: -1
  //   });
  //   game.anims.create({
  //     key: "SO",
  //     frames: frameAnimationSudOuest,
  //     frameRate: 10,
  //     repeat: -1
  //   });
  //   game.anims.create({
  //     key: "idleNO",
  //     frames: idleNO,
  //     frameRate: 10,
  //     repeat: -1
  //   });
  //   game.anims.create({
  //     key: "idleNE",
  //     frames: idleNE,
  //     frameRate: 10,
  //     repeat: -1
  //   });
  //   game.anims.create({
  //     key: "idleSO",
  //     frames: idleSO,
  //     frameRate: 10,
  //     repeat: -1
  //   });
  //   game.anims.create({
  //     key: "idleSE",
  //     frames: idleSE,
  //     frameRate: 10,
  //     repeat: -1
  //   });
  // }
}
